import React from 'react';

export const statusLabelForOverall = (overallStatus) => {
  switch (overallStatus) {
    case 'EXECUTED_SUCCESS':
      return 'Deployment executed · Succeeded';
    case 'EXECUTED_FAILED':
      return 'Deployment executed · Failed';
    case 'APPROVED_PENDING_EXECUTION':
      return 'Approved · Awaiting execution';
    case 'EXPIRED':
      return 'Expired';
    default:
      return 'Awaiting approval';
  }
};

export const statusToneForOverall = (overallStatus) => {
  switch (overallStatus) {
    case 'EXECUTED_SUCCESS':
      return 'success';
    case 'EXECUTED_FAILED':
      return 'failed';
    case 'APPROVED_PENDING_EXECUTION':
      return 'amber';
    case 'EXPIRED':
      return 'gray';
    default:
      return 'gray';
  }
};

const StatusPill = ({ overallStatus, label }) => {
  const tone = statusToneForOverall(overallStatus);
  const text = label || statusLabelForOverall(overallStatus);
  return <span className={`status-badge ${tone}`}>{text}</span>;
};

export default StatusPill;
